






































































































































































































































































































import "./card-detail.less";
import Vue from "vue";
import iForm from "iView";
import moment from "moment";
import { Model } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../common/user-avatar.vue";
import ResizableTextarea from "../common/ResizableTextarea.js";
import TextareaAutosize from "../common/TextareaAutosize.vue";
import AttachmentEditor from "../goals/attachment-editor.vue";
import { Container, Draggable } from "vue-smooth-dnd";
let _ = require("lodash");

export default Vue.extend({
  name: "CardDetail",
  components: { UserAvatar, AttachmentEditor, Container, Draggable, ResizableTextarea, TextareaAutosize },
  props: {
    card: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      title: "",
      description: "",

      showAssignments: false,
      selectedMemberIds: [],
      members: [],

      showDueDate: false,
      dueDateSetting: {
        completed: false,
        dueDate: null,
        date: null,
        time: null,
      },
      dueDateRules: {
        date: [
          {
            type: "date",
            required: true,
            message: "Please select due date",
            trigger: "blur",
          },
        ],
        time: [
          {
            type: "string",
            required: true,
            message: "lease select due time",
            trigger: "blur",
          },
        ],
      },
      dueDateTimeOptions: [
        { value: "00:00", label: "12:00 AM", disabled: false },
        { value: "00:30", label: "12:30 AM", disabled: false },
        { value: "01:00", label: "1:00 AM", disabled: false },
        { value: "01:30", label: "1:30 AM", disabled: false },
        { value: "02:00", label: "2:00 AM", disabled: false },
        { value: "02:30", label: "2:30 AM", disabled: false },
        { value: "03:00", label: "3:00 AM", disabled: false },
        { value: "03:30", label: "3:30 AM", disabled: false },
        { value: "04:00", label: "4:00 AM", disabled: false },
        { value: "04:30", label: "4:30 AM", disabled: false },
        { value: "05:00", label: "5:00 AM", disabled: false },
        { value: "05:30", label: "5:30 AM", disabled: false },
        { value: "06:00", label: "6:00 AM", disabled: false },
        { value: "06:30", label: "6:30 AM", disabled: false },
        { value: "07:00", label: "7:00 AM", disabled: false },
        { value: "07:30", label: "7:30 AM", disabled: false },
        { value: "08:00", label: "8:00 AM", disabled: false },
        { value: "08:30", label: "8:30 AM", disabled: false },
        { value: "09:00", label: "9:00 AM", disabled: false },
        { value: "09:30", label: "9:30 AM", disabled: false },
        { value: "10:00", label: "10:00 AM", disabled: false },
        { value: "10:30", label: "10:30 AM", disabled: false },
        { value: "11:00", label: "11:00 AM", disabled: false },
        { value: "11:30", label: "11:30 AM", disabled: false },
        { value: "12:00", label: "12:00 PM", disabled: false },
        { value: "12:30", label: "12:30 PM", disabled: false },
        { value: "13:00", label: "1:00 PM", disabled: false },
        { value: "13:30", label: "1:30 PM", disabled: false },
        { value: "14:00", label: "2:00 PM", disabled: false },
        { value: "14:30", label: "2:30 PM", disabled: false },
        { value: "15:00", label: "3:00 PM", disabled: false },
        { value: "15:30", label: "3:30 PM", disabled: false },
        { value: "16:00", label: "4:00 PM", disabled: false },
        { value: "16:30", label: "4:30 PM", disabled: false },
        { value: "17:00", label: "5:00 PM", disabled: false },
        { value: "17:30", label: "5:30 PM", disabled: false },
        { value: "18:00", label: "6:00 PM", disabled: false },
        { value: "18:30", label: "6:30 PM", disabled: false },
        { value: "19:00", label: "7:00 PM", disabled: false },
        { value: "19:30", label: "7:30 PM", disabled: false },
        { value: "20:00", label: "8:00 PM", disabled: false },
        { value: "20:30", label: "8:30 PM", disabled: false },
        { value: "21:00", label: "9:00 PM", disabled: false },
        { value: "21:30", label: "9:30 PM", disabled: false },
        { value: "22:00", label: "10:00 PM", disabled: false },
        { value: "22:30", label: "10:30 PM", disabled: false },
        { value: "23:00", label: "11:00 PM", disabled: false },
        { value: "23:30", label: "11:30 PM", disabled: false },
      ],
      dueDateTooltips: {
        "due-date-complete": "This card is completed.",
        "due-date-expired": "This card is overdue.",
        "due-date-warning": "This card is due in less than twenty-four hours.",
        "due-date-normal": "This card is due in the future.",
      },

      attachments: [],
      showAttachmentEditor: false,
      disableAttachmentEdit: false,

      showChecklistCreator: false,
      showChecklistEditor: false,
      checklistEditorStyles: {},
      edittingChecklist: null,
      edittingChecklistContent: "",
      showItemCreator: false,
      showItemEditor: false,
      itemEditorStyles: {},
      edittingItem: null,
      edittingItemContent: "",
      checklists: [
        {
          id: "1",
          title: "My List",
          showItemCreator: false,
          items: [{ id: 1, content: "item 1", done: true }],
        },
      ],
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: true,
      },
    };
  },
  watch: {
    showModal(newVal) {
      let context = this as any;

      if (newVal === true) {
        context.title = context.card.title;
        context.description = context.card.description;

        let members = context.currentProject ? context.currentProject.members : [];
        context.selectedMemberIds = context.card && context.card.selectedMemberIds ? context.card.selectedMemberIds : [];
        context.members = members.map((member) => {
          let result = Object.assign({}, member);

          result.selected = !!_.find(context.selectedMemberIds, function (id) {
            return id === member.memberId;
          });

          return result;
        });

        if (context.card.dueDateSetting) {
          let setting = context.card.dueDateSetting;
          context.dueDateSetting = Object.assign(
            {
              date: setting.dueDate ? new Date(moment(setting.dueDate).format("MM/DD/YYYY")) : null,
              time: setting.dueDate ? moment(setting.dueDate).format("HH:mm") : null,
            },
            context.card.dueDateSetting
          );
        }

        context.attachments = context.card.attachments ? context.card.attachments.map((attachment) => Object.assign({}, attachment)) : [];

        let checklists = context.card && context.card.checklists ? context.card.checklists : [];
        context.checklists = checklists.map((checklist) => {
          return Object.assign({}, checklist, {
            items: checklist.items.map((item) => {
              return Object.assign({}, item);
            }),
          });
        });
      }
    },
  },
  computed: {
    ...mapState("project", ["currentProject"]),
    ...mapGetters("project", ["canEditCurrentProject"]),
    showModal(): boolean {
      return this.showEditor;
    },

    dueDateClass() {
      let context = this as any;

      if (context.dueDateSetting && context.dueDateSetting.dueDate) {
        let dueDate = new Date(context.dueDateSetting.dueDate);
        let today = new Date();
        let tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);

        if (context.dueDateSetting.completed === true) {
          return "due-date-complete";
        } else if (dueDate < today) {
          return "due-date-expired";
        } else if (dueDate < tomorrow) {
          return "due-date-warning";
        }
      }

      return "due-date-normal";
    },

    isDueDateUpdate() {
      let context = this as any;

      return context.dueDateSetting && context.dueDateSetting.dueDate;
    },
  },
  methods: {
    handleSave($event) {
      let context = this as any;
      this.$emit(
        "save",
        {
          title: context.title,
          description: context.description,
          selectedMemberIds: context.selectedMemberIds,
          attachments: context.attachments,
          dueDateSetting: { completed: context.dueDateSetting.completed, dueDate: context.dueDateSetting.dueDate },
          checklists: context.checklists,
        },
        $event
      );
    },
    handleMemberAssign(member) {
      member.selected = !member.selected;

      let context = this as any;
      context.selectedMemberIds = context.members
        .filter((member) => member.selected === true)
        .map((member) => {
          return member.memberId;
        });
    },

    getDueDateString(dueDate) {
      return moment(dueDate).format("MMM D, YYYY hh:mm a");
    },

    handleSaveDueDate() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      let form = this.$refs.DueDateForm;
      (form as any).validate((valid: boolean) => {
        if (valid) {
          let setting = { completed: this.dueDateSetting.completed, dueDate: new Date(`${moment(this.dueDateSetting.date).format("YYYY-MM-DD")} ${this.dueDateSetting.time}`) };
          this.dueDateSetting.dueDate = new Date(`${moment(this.dueDateSetting.date).format("YYYY-MM-DD")} ${this.dueDateSetting.time}`);
          //this.$emit("save", setting);
          target.disabled = false;
          this.showDueDate = false;
        } else {
          target.disabled = false;
        }
      });
    },
    handleRemoveDueDate() {
      event.preventDefault();
      let context = this as any;
      context.dueDateSetting.completed = false;
      context.dueDateSetting.dueDate = null;
      context.dueDateSetting.date = null;
      context.dueDateSetting.time = null;
      context.showDueDate = false;
    },
    handleAddAttachment() {
      this.attachments.push({
        link: null,
        title: "",
        type: null,
        status: "new",
      });
    },
    handleAttachmentEditting() {
      this.disableAttachmentEdit = true;
    },
    handleAttachmentEdittingEnd() {
      this.disableAttachmentEdit = false;
    },
    handleAttachmentCancelNew() {
      if (this.attachments.length > 0 && this.attachments[this.attachments.length - 1]) {
        this.attachments.pop();
      }
    },
    handleAttachmentRemove(attachment) {
      this.attachments = this.attachments.filter((a) => {
        return a.link !== attachment.link;
      });
    },
    //for checklist
    getChecklistPayload(checklistId) {
      return (index) => {
        return this.checklists.filter((checklist) => checklist.id === checklistId)[0].items[index];
      };
    },
    onDrop(checklistId, dropResult) {
      let checklist = this.checklists.filter((checklist) => checklist.id === checklistId)[0];
      checklist.items = this.applyDrag(checklist.items, dropResult);
    },
    applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult;
      if (removedIndex === null && addedIndex === null) return arr;

      const result = [...arr];
      let itemToAdd = payload;

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }

      return result;
    },
    handleAddChecklist($event) {
      this.edittingChecklist = null;
      this.edittingChecklistContent = "";
      this.showChecklistEditor = true;
    },
    handleEditChecklist(checklist, $event) {
      this.edittingChecklist = checklist;
      this.edittingChecklistContent = checklist ? checklist.title : "";
      this.getChecklistEditorPosition($event.target.parentElement);
      this.showChecklistEditor = true;
    },
    getChecklistEditorPosition(element) {
      let offsetLeft = 0;
      let offsetTop = 0;
      do {
        if (!isNaN(element.offsetLeft)) {
          offsetLeft += element.offsetLeft - element.scrollLeft;
          offsetTop += element.offsetTop - element.scrollTop;
        }
      } while ((element = element.offsetParent));

      if (offsetLeft < 0) {
        offsetLeft = 0;
      }

      if (offsetTop < 0) {
        offsetTop = 0;
      }

      this.checklistEditorStyles = {
        left: `${offsetLeft}px`,
        top: `${offsetTop}px`,
        position: "absolute",
      };
    },
    handleChecklistCreatorPopup() {
      this.edittingChecklistContent = "";
    },
    handleSaveNewChecklist() {
      if (this.edittingChecklistContent && this.edittingChecklistContent != "") {
        this.checklists.push({
          id: this.uuid(),
          title: this.edittingChecklistContent,
          showItemCreator: false,
          items: [],
        });
      }

      this.showChecklistCreator = false;
    },
    handleSaveChecklist() {
      if (this.edittingChecklistContent && this.edittingChecklistContent != "") {
        if (this.edittingChecklist) {
          this.edittingChecklist.title = this.edittingChecklistContent;
        }
      }

      this.showChecklistEditor = false;
    },
    removeChecklist(checklist) {
      for (var i = 0; i < this.checklists.length; i++) {
        if (this.checklists[i] === checklist) {
          this.checklists.splice(i, 1);
        }
      }
    },
    handleCheck(member) {
      member.done = !member.done;
    },
    removeItem(item, checklist) {
      for (var i = 0; i < checklist.items.length; i++) {
        if (checklist.items[i] === item) {
          checklist.items.splice(i, 1);
        }
      }
    },
    handleAddItem(checklist, item, $event) {
      this.edittingChecklist = checklist;
      this.edittingItem = item;
      this.edittingItemContent = "";
      checklist.showItemCreator = true;
    },
    handleEditItem(checklist, item, $event) {
      this.edittingChecklist = checklist;
      this.edittingItem = item;
      this.edittingItemContent = item ? item.content : "";
      this.getItemEditorPosition($event.target.parentElement);
      this.showItemEditor = true;
    },
    getItemEditorPosition(element) {
      let offsetLeft = 0;
      let offsetTop = 0;
      do {
        // if ((" " + element.className + " ").indexOf(" card-scene ") > -1) {
        //   break;
        // }

        if (!isNaN(element.offsetLeft)) {
          offsetLeft += element.offsetLeft - element.scrollLeft;
          offsetTop += element.offsetTop - element.scrollTop;
        }
      } while ((element = element.offsetParent));

      if (offsetLeft < 0) {
        offsetLeft = 0;
      }

      if (offsetTop < 0) {
        offsetTop = 0;
      }

      this.itemEditorStyles = {
        left: `${offsetLeft}px`,
        top: `${offsetTop}px`,
        position: "absolute",
      };
    },
    handleSaveNewItem() {
      if (this.edittingItemContent && this.edittingItemContent != "") {
        this.edittingChecklist.items.push({
          id: this.uuid(),
          content: this.edittingItemContent,
          done: false,
        });
      }

      this.edittingChecklist.showItemCreator = false;
    },
    handleSaveItem() {
      if (this.edittingItemContent && this.edittingItemContent != "") {
        if (this.edittingItem) {
          this.edittingItem.content = this.edittingItemContent;
        }
      }

      this.showItemEditor = false;
    },
    getPercentage(checklist) {
      return checklist && checklist.items && checklist.items.length > 0 ? Math.round((checklist.items.filter((item) => item.done === true).length / checklist.items.length) * 100) : 0;
    },
    uuid() {
      // Public Domain/MIT
      var d = new Date().getTime(); //Timestamp
      var d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
          //Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          //Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      });
    },
  },
});
